import { Plus, Trash2 } from 'lucide-react'
import type { FormData } from '@/types/apply'

interface StepDemosProps {
  formData: FormData
  updateDemoLinks: (links: string[]) => void
  errors: Record<string, string>
  clearError: (field: string) => void
}

export default function StepDemos({ formData, updateDemoLinks, errors, clearError }: StepDemosProps) {
  const links = formData.demo_links

  function updateLink(index: number, value: string) {
    const next = [...links]
    next[index] = value
    updateDemoLinks(next)
    clearError(`demo_link_${index}`)
    clearError('demo_links')
  }

  function addLink() {
    if (links.length < 5) updateDemoLinks([...links, ''])
  }

  function removeLink(index: number) {
    if (links.length <= 1) return
    updateDemoLinks(links.filter((_, i) => i !== index))
  }

  return (
    <div className="space-y-5">
      <p className="text-sm text-white/50">
        Share links to your music on SoundCloud, Spotify, YouTube, Dropbox, or any streaming platform.
      </p>

      {errors.demo_links && <p className="apply-error-text">{errors.demo_links}</p>}

      {links.map((link, i) => (
        <div key={i} className="flex gap-2">
          <input
            type="url"
            className={`apply-input flex-1 ${errors[`demo_link_${i}`] ? 'apply-input-error' : ''}`}
            placeholder="https://soundcloud.com/your-track"
            value={link}
            onChange={e => updateLink(i, e.target.value)}
            autoFocus={i === 0}
          />
          <button
            type="button"
            className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl border border-white/10 text-white/30 hover:border-red-500/30 hover:text-red-400 disabled:opacity-30"
            onClick={() => removeLink(i)}
            disabled={links.length <= 1}
            aria-label="Remove link"
          >
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      ))}

      {links.length < 5 && (
        <button
          type="button"
          onClick={addLink}
          className="flex items-center gap-2 text-sm text-[#ff6a1a] hover:text-[#ff8a4a] transition-colors"
        >
          <Plus className="h-4 w-4" />
          Add another link
        </button>
      )}

      {Object.keys(errors).filter(k => k.startsWith('demo_link_')).map(k => (
        <p key={k} className="apply-error-text">{errors[k]}</p>
      ))}
    </div>
  )
}
